import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class ATRConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Atr
  static abbreviation = 'atr'
  static label = 'Average True Range'
  static shortLabel = 'ATR'
  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
}
